import apiStatus from "../../_helpers/apiStatus";
import dialogUtil from "../../_helpers/dialogUtil";
import formValidationUtil from '../../_helpers/formValidationUtil';
import userRoles from "../../_helpers/userRoles";
import Swal from "sweetalert2";
import treeUtil from '../../_helpers/treeUtil';
import datatableUtil from '../../_helpers/datatableUtil';
import nodeTypes from '../../_helpers/nodeType';

class UserController {
  constructor(ClientService, AuthService, $scope, $state) {
    "ngInject";
    this.name = 'user';
    this.formId = 'user_form';

    this.clientService = ClientService;
    this.authService = AuthService;
    this.scope = $scope;
    this.state = $state;
    this.allUsers = [];
    this.filteredUsers = [];
    this.allAppsRoles = [];
    this.formValidator = undefined;
    this.resetForm();

    this.permissionsTreeIdDivision = "permissions-tree-division"
    this.permissionsTreeIdProject = "permissions-tree-project"
    this.userPermissionsDivision = undefined;
    this.userPermissionsProject = undefined;
    this.checkboxTreeOptions = { checkbox: "true" }
    this.PROJECT_ACCESS_COLUMNS = [
      {
        field: 'region',
        title: 'Region',
        textAlign: 'left',
      },
      {
        field: 'division',
        title: 'Division',
        textAlign: 'left',
      },
      {
        field: 'community',
        title: 'Community',
        textAlign: 'left',
      },
    ];

  }

  $onInit() {
    $('.app').css('background-image', '');

    const parent = this;
    $( document ).ready(function() {
      treeUtil.initializeTree(parent.permissionsTreeIdDivision, parent.userPermissionsDivision, parent.checkboxTreeOptions);
      treeUtil.initializeTree(parent.permissionsTreeIdProject, parent.userPermissionsProject, parent.checkboxTreeOptions);
    });

    $("input").attr("autocomplete", "off");   //turn autocomplete off on all input fields

    this.formValidator = formValidationUtil.initValidation(this.formId);

    $('#search_query').on('input',function(){
      parent.filterUsers();
      parent.scope.$apply();
    });

    $('#userContainer').on('click','.userRow', function(){
      parent.rowClicked(this);
    });

    $('#' + parent.formId + ' .phone').on('input', function (event) {
      let inputType = event.originalEvent.inputType;

      if(inputType && !inputType.startsWith('insert')) {
        return;
      }

      //only format if not erasing
      parent.formatPhone($(this));

      if(!inputType) {
        parent.formValidator.validate();
      }
    });

    this.getAllUsersApplicationsRoles();
    this.getAllApplicationsRoles();
  }

  resetForm() {
    this.clickedData = {};
    this.userAppRole = [false,0,0,0,0,0,0,0,0,0];  //This has to be as long as the number of apps
  }

  formatPhone(elem) {
    let phoneNumber = elem.val();

    const cleanNum = phoneNumber.toString().replace(/[\-]/g, '');
    const match = cleanNum.match(/^(\d{3,3})(\d{0,3})(\d{0,4})(.*)$/);

    let newPhone = phoneNumber;
    if (match) {
      newPhone = match[1] + '-' + (match[2] ? match[2].length < 3 ? match[2] : match[2] + "-" : "") + match[3] + match[4];
    }

    $(elem).val(newPhone);
  }

  getAllApplicationsRoles() {
    this.clientService.getAllApplicationsRoles((result) => {

      if (result.apiStatus === apiStatus.SUCCESS) {
        this.allAppsRoles = result.dataList;

        for (const appRole of this.allAppsRoles) {
          appRole.appRoleList.splice(0,0,{name: 'No Access', id: 0});
        }

        this.scope.$apply();
      } else {
        dialogUtil.showErrorMessage("Error getting applications: " + result.apiStatus);
      }
    })
  }

  getAllUsersApplicationsRoles() {
    this.clientService.getAllUsersApplicationsRoles((result) => {
      if (result.apiStatus === apiStatus.SUCCESS) {
        this.allUsers = result.dataList;
        this.filterUsers();
        this.scope.$apply();
        this.formValidator.resetForm();
      } else {
        dialogUtil.showErrorMessage("Error getting users: " + result.apiStatus);
      }
    })
  }


  filterUsers() {
    let searchText = $('#search_query').val();

    let userStatus = $('input[name="userStatus"]:checked').val();

    this.filteredUsers = [];

    this.allUsers.forEach(user => {
      let fullName = (user.firstName + ' ' + user.lastName).toLowerCase();
      if(user.status === userStatus && (searchText.length < 1 || fullName.includes(searchText.toLowerCase()))) {
        this.filteredUsers.push({
          id: user.userId,
          name: user.firstName + ' ' + user.lastName,
          initials: user.firstName.charAt(0) + user.lastName.charAt(0)
        });
      }
    });
  }

  getUserRoleSelected(roleId) {
    return this.clickedData.appRoleIdList && this.clickedData.appRoleIdList.includes(roleId);
  }

  showResetPasswordButton() {
    return this.clickedData.type === 'O';
  }

  rowClicked(element) {
    //Remove the highlight from any other div
    $(element).parent('div').find('div').removeClass('highlight');
    $(element).addClass('highlight');

    let id = parseInt($(element).attr('id'));

    this.clickedData = this.allUsers.find(elem => elem.userId === id);
    this.formValidator.resetForm();

    this.updateUserRoleState();

    this.getUserPermissions();

    this.scope.$apply();  //Needed to show the Reset Password button on select
  }

  updateUserRoleState() {

    //Figure out which role for each application that this user has
    for(const app of this.allAppsRoles) {
      let appId = app.appId;
      this.userAppRole[appId-1] = 0;  //default to no access unless I find it
      for(const userRoleId of this.clickedData.appRoleIdList) {
        for(const appRole of app.appRoleList) {
          if(appRole.id === userRoleId) {
            this.userAppRole[appId-1] = userRoleId;
          }
        }
      }
    }

    this.userAppRole[0]=this.clickedData.appRoleIdList.includes(1);
  }

  newUserClicked() {
    this.resetForm();
    this.formValidator.resetForm();
    this.scope.$apply();
  }

  getRoleData(data) {
    let roleList = [];
    this.allAppsRoles.forEach((elem) => {
      //go through the apps and get the dropdown value for each, which is already in the data as appId{appId}
      let key = 'appId' + elem.appId
      let value = data[key];
      if (value !== 'number:0') {
        roleList.push(value.split(':')[1]);
      }
      data[key] = null;
    });

    //checkboxes are different in that the val is the same checked or unchecked, so need to be different here
    roleList.push($('#portalAdmin').is(":checked") ? ''+userRoles.PORTAL_ADMIN : ''+userRoles.PORTAL_USER);

    data['applicationRoleIds'] = roleList;
  }

  saveButtonClicked() {
    let tmpData = formValidationUtil.validateFormDetails(this.formId);

    if (!tmpData) {
      dialogUtil.showErrorMessage("Please review and fix all fields before resubmitting");
      return;
    } else {
      this.getRoleData(tmpData);
    }

    this.clientService.updateUser(this.clickedData.userId, tmpData, (result) => {
      if (result.apiStatus === "SUCCESS") {
        this.state.reload();   //refresh the page
        dialogUtil.showSuccessMessage("User saved Successfully");
      } else {
        dialogUtil.showErrorMessage("User save failed");
      }
    });
  }

  //Called from the table to edit comment;  also called from the function from the HTML
  async resetPasswordClicked() {
    const parent = this;
    let popupHtml = $("#resetPasswordPopup").html();
    popupHtml = popupHtml.replaceAll('password1','p1').replaceAll('resetPasswordError','rpe');
    const { value: newPassword } = await Swal.fire({
      title: 'Reset Password',
      html: popupHtml,
      showCancelButton: true,
      width: '30%',
      inputAttributes: {
        id: "resetPswdPopup",
      },
      preConfirm: () => {
        let p1 = $('#p1').val();
        if(p1.length < 8) {
          $('#rpe').html('Passwords must be at least 8 characters');
          return false;
        }

        return p1;
      }
    })
    if(newPassword) {
      parent.authService.resetPasswordForUser(parent.clickedData.userId, newPassword, (result)=>{
        if(result.apiStatus === 'SUCCESS') {
          dialogUtil.showSuccessMessage("Password Reset!");
        } else {
          dialogUtil.showErrorMessage("Error resetting password: " + result.apiStatus);
        }
      });
    }
  }

  getPermissionType() {

    if(this.clickedData && this.clickedData.type) {
      let appRoleIdList = this.clickedData.appRoleIdList;
      let userType = this.clickedData.type;
      if(userType === "C") {
        return 3;  //contact only user
      }
      if(appRoleIdList.includes(7) || appRoleIdList.includes(8) || appRoleIdList.includes(9) ||
        appRoleIdList.includes(11) || appRoleIdList.includes(15) ) {
        return 2;  //Role requires permissions
      }

      return 1;  //Roles do NOT require permissions
    }

    return 0;  //Show empty tab
  }

  getUserPermissions() {
    if (this.getPermissionType() === 2) {

      this.clientService.getUserPermissions(this.clickedData.userId, (result) => {
        if (result.apiStatus === apiStatus.SUCCESS) {
          this.userPermissionsDivision = result.divisionTierList;
          this.userPermissionsProject = result.projectTierList;
          treeUtil.uncheckAll(this.permissionsTreeIdDivision);
          treeUtil.uncheckAll(this.permissionsTreeIdProject);

          treeUtil.refreshTree(this.permissionsTreeIdDivision, this.userPermissionsDivision, false);
          treeUtil.refreshTree(this.permissionsTreeIdProject, this.userPermissionsProject, false);

          this.loadProjectAccessTable();
          this.scope.$apply()
        } else {
          dialogUtil.showErrorMessage("Error getting user permissions: " + result.apiStatus);
        }
      });
    }
  }

  loadProjectAccessTable() {
    let projectAccessData = [];
    this.userPermissionsDivision.forEach(region => {
      let regName = region.text;
      region.children.forEach(division => {
        let divName = division.text;

        if(division.state) {  //is checked
          //Get the projects for this division
          this.userPermissionsProject.forEach(div => {
            if(div.dbId === division.dbId) {
              div.children.forEach(proj => {
                projectAccessData.push({region: regName, division: divName, community: proj.text});
              });
            }
          });
        }
      });
    });

    this.userPermissionsProject.forEach(division => {
      let divName = division.text;
      division.children.forEach(project => {
        let projName = project.text;

        if(project.state) {  //is checked
          //Add to list if it does not exist already
          let regName = this.getRegion(division.dbId);
          if(!this.projectExists(projectAccessData, regName, divName, projName)) {
            projectAccessData.push({region: regName, division: divName, community: projName});
          }
        }
      });
    });

    if (this.datatable) {
      this.datatable.destroy();
    }

    this.datatable = datatableUtil.initializeTable('permission-project-access', this.PROJECT_ACCESS_COLUMNS,
      projectAccessData, { pagination: false, sortable: true});
  }

  getRegion(divId) {
    let reg = "";

    this.userPermissionsDivision.forEach(region => {
      region.children.forEach(division => {
        if(division.dbId === divId) {
          reg=region.text;
        }
      });
    });

    return reg;
  }

  projectExists(projectAccessData, regName, divName, projName) {
    let ret = false;
    projectAccessData.forEach(data => {
      if(data.division === divName && data.community === projName && data.region === regName) {
        ret = true;
      }
    });

    return ret;
  }

  savePermissions() {
    let divisionIds = this.getSelectedNodesInTree(this.permissionsTreeIdDivision);
    let projectIds = this.getSelectedNodesInTree(this.permissionsTreeIdProject);

    if (divisionIds.length > 0 || projectIds.length > 0) {
      let data = {userId: this.clickedData.userId, divisionIds: divisionIds, projectIds: projectIds};
      this.clientService.updateUserPermissions(data, (result) => {
        if (result.apiStatus === apiStatus.SUCCESS) {
          this.getUserPermissions();
          dialogUtil.showSuccessMessage("User permissions have been updated successfully!")
        } else {
          dialogUtil.showErrorMessage("Error updating user permissions: " + result.apiStatus);
        }
      });
    } else {
      dialogUtil.showErrorMessage("Please select at least one division or project for permission access")
    }
  }

  selectPressed() {
    $('.btnCheckBox').prop('checked', this.selectAll);

    this.selectAll = !this.selectAll
  }

  getSelectedNodesInTree(treeId) {
    let nodeType = treeId === this.permissionsTreeIdDivision ? nodeTypes.DIVISION : nodeTypes.PROJECT;
    let selectedNodes = treeUtil.getCheckedNodes(treeId);
    let ids = [];
    selectedNodes.forEach((node) => {
      if (node && node.nodeType === nodeType) {
        ids.push(node.dbId);
      }
    });

    return ids;
  }

}
export default UserController;





// WEBPACK FOOTER //
// ./client/app/components/user/user.controller.js